import React from 'react';
import PropTypes from 'prop-types';
import StepProgress from './StepProgress';
import WizardSidebar from './WizardSidebar';
import { wizardContainer, wizardHeader, wizardBody, wizardMain } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var WizardLayout = function WizardLayout(_ref) {
  var title = _ref.title,
      steps = _ref.steps,
      activeStep = _ref.activeStep,
      onStepClick = _ref.onStepClick,
      onBack = _ref.onBack,
      borrower = _ref.borrower,
      guarantor = _ref.guarantor,
      credit = _ref.credit,
      children = _ref.children;
  return ___EmotionJSX("div", {
    css: wizardContainer
  }, ___EmotionJSX("header", {
    css: wizardHeader
  }, ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    className: "wizard-back",
    onClick: onBack
  }, ___EmotionJSX("i", {
    className: "las la-arrow-left"
  }), ___EmotionJSX("span", null, "\u041D\u0430\u0437\u0430\u0434 \u043A\u044A\u043C \u043A\u0440\u0435\u0434\u0438\u0442\u0438")), ___EmotionJSX("span", {
    className: "wizard-title"
  }, title), ___EmotionJSX("div", {
    style: {
      width: 140
    }
  })), ___EmotionJSX(StepProgress, {
    steps: steps,
    activeStep: activeStep,
    onStepClick: onStepClick
  }), ___EmotionJSX("div", {
    css: wizardBody
  }, ___EmotionJSX("main", {
    css: wizardMain
  }, children), ___EmotionJSX(WizardSidebar, {
    borrower: borrower,
    guarantor: guarantor,
    credit: credit,
    activeStep: activeStep
  })));
};

WizardLayout.propTypes = {
  title: PropTypes.string,
  steps: PropTypes.array.isRequired,
  activeStep: PropTypes.number.isRequired,
  onStepClick: PropTypes.func,
  onBack: PropTypes.func,
  borrower: PropTypes.object,
  guarantor: PropTypes.object,
  credit: PropTypes.object,
  children: PropTypes.node
};
export default WizardLayout;